<form class="form-horizontal"  #form="ngForm" (ngSubmit)="onSubmit()">
  <div class="form-group" [class.has-error]="price.invalid && price.touched">
    <label class="control-label col-sm-3">{{ 'Price Agreed' | translate }}</label>
    <div class="col-sm-9 input-group">
      <span class="form-group input-group-btn input-group-addon">
      {{country.currency_symbol}}
      </span>
      <input [focus]="inputFocused" type="number" name="price" class="form-control" placeholder="{{ 'Enter charged price' | translate }}" required [(ngModel)]="priceBilled" #price="ngModel">
    </div>
  </div>
  <div class="form-group">
    <div class="col-sm-offset-3 col-sm-9 div-btn-right">
      <button type="submit" class="btn btn-primary btn-sm"  [disabled]="form.form.invalid || form.form.pending || isDisabled">
        {{ 'Charge' | translate }}
      </button>
    </div>
  </div>
</form>
